import { OAuthServiceType } from "@common/constants";
import {
    ConnectionProviderType,
    FinancialConnection,
} from "@common/types/financialConnection";
import { useFixStripeConnectionsMutation } from "@mutations/stripeConnection";
import { useFixGustoConnectionsMutation } from "@mutations/gustoConnection";
import { useFixRampConnectionsMutation } from "@mutations/rampConnection";
import { ConnectionFix, useOAuthConnectionFix } from "./useOAuthConnectionFix";

export interface FinancialOAuthFixConfig {
    scope: OAuthServiceType;
    useFixMutation: (onSuccess?: () => void) => {
        mutate: (payload: {
            code: string;
            connection: FinancialConnection;
        }) => void;
        isPending: boolean;
    };
}

export const FINANCIAL_OAUTH_FIX_CONFIGS: Partial<
    Record<ConnectionProviderType, FinancialOAuthFixConfig>
> = {
    [ConnectionProviderType.STRIPE]: {
        scope: OAuthServiceType.STRIPE,
        useFixMutation: useFixStripeConnectionsMutation,
    },
    [ConnectionProviderType.GUSTO]: {
        scope: OAuthServiceType.GUSTO,
        useFixMutation: useFixGustoConnectionsMutation,
    },
    [ConnectionProviderType.RAMP]: {
        scope: OAuthServiceType.RAMP,
        useFixMutation: useFixRampConnectionsMutation,
    },
};

export function useFinancialConnectionOAuthFix({
    connection,
    config: { scope, useFixMutation },
    onFixed,
}: {
    connection: FinancialConnection;
    config: FinancialOAuthFixConfig;
    onFixed?: () => void;
}): ConnectionFix {
    // oxlint-disable-next-line react/hooks -- intended skip: ConnectionFixer keys this by provider, so each mount calls one fixed hook
    const mutation = useFixMutation(onFixed);
    const { startFix } = useOAuthConnectionFix({
        scope,
        onCode: (code) => mutation.mutate({ code, connection }),
    });
    return { startFix, isFixing: mutation.isPending };
}
